import { PRECONNECT_CHECK_BLOCKLIST } from '@angular/common';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ChunkReloadErrorHandler } from '@core/error-handling/chunk-reload.error-handler';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { authInterceptor } from '@core/auth/auth.interceptor';
import { errorInterceptor } from '@core/http/error.interceptor';
import { acceptLanguageInterceptor } from '@core/i18n/accept-language.interceptor';
import { LocaleService } from '@core/i18n/locale.service';
import { AppearanceService } from '@core/appearance/appearance.service';
import { translateFeatureLoaderProvider } from '@core/i18n/translate-feature-loader';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: PRECONNECT_CHECK_BLOCKLIST, useValue: ['dev.cuminanza.ch', 'app.cuminanza.ch'] },
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: ChunkReloadErrorHandler },
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(
      withXhr(),
      withInterceptors([authInterceptor, errorInterceptor, acceptLanguageInterceptor]),
    ),
    provideAnimations(),
    provideTranslateService({
      fallbackLang: 'de',
      lang: 'de',
      loader: translateFeatureLoaderProvider,
    }),
    provideAppInitializer(() => inject(LocaleService).init()),
    provideAppInitializer(() => inject(AppearanceService).init()),
  ],
};
